import storeDateSelectorResolve from "../../directive/store-date-selector/store-date-selector.resolve";

export default function routes($stateProvider) {
	$stateProvider.state("reviewsRankingPage", {
		url: "/reviewsRanking/:stores?startDate&endDate",
		template: require("./reviewsRanking.html"),
		resolve: {
			...storeDateSelectorResolve,
			brand: [
				"Brand",
				function(Brand) {
					return Brand.get();
				}
			],
			storesInfoLoader: [
				"Review",
				"selectedStore",
				"endDate",
				"startDate",
				function(Review, selectedStore, endDate, startDate) {
					return _ =>
						Review.storeInfo({
							stores: JSON.stringify(selectedStore.storeIds),
							startDate,
							endDate
						});
				}
			],
			storesInfo: [
				"storesInfoLoader",
				function(storesInfoLoader) {
					return storesInfoLoader();
				}
			]
		},
		controller: "ReviewsRankingController",
		controllerAs: "reviewsRanking"
	});
}

routes.$inject = ["$stateProvider"];



// WEBPACK FOOTER //
// ./src/page/reviewsRanking/reviewsRanking.routes.js